import { PropsWithChildren } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Link from '@mui/material/Link';

import { useHostingResellerSsoWhm } from '@newfold/huapi-js';

import { useAlert } from '~/components/Alerts/alertsStore';
import useAccount from '~/hooks/useAccount';
import { useBrandInfo } from '~/hooks/useBrandInfo';

import SSOComponent from '../index';
import { SSO_HOOK_OPTIONS } from '../utils/helpers';
import { BaseSsoProps } from '../utils/types';

interface ResellerWhmSSOProps extends BaseSsoProps {
  hostingId?: string | number;
}

const ResellerWhmSSO = ({
  children = undefined,
  hostingId = undefined,
  disabled = false,
  ...props
}: PropsWithChildren<ResellerWhmSSOProps>) => {
  const { t } = useTranslation('site', { useSuspense: false });
  const generateAlert = useAlert();
  const { phoneNumberFormatted, phoneNumberHref } = useBrandInfo();
  const { id: accountHostingId } = useAccount();
  const accountId = hostingId || accountHostingId;

  const sso = useHostingResellerSsoWhm(accountId, SSO_HOOK_OPTIONS);

  const onAction = (error?: string) => {
    if (error === 'notResellerHosting') {
      generateAlert({
        severity: 'error',
        description: (
          <Trans
            i18nKey={t('ssoLink.notResellerHosting')}
            values={{ phoneNumber: phoneNumberFormatted }}
            components={{ Link: <Link href={phoneNumberHref} /> }}
          />
        ),

        showCloseBtn: true,
      });
    }
  };

  return (
    <SSOComponent
      sso={sso}
      isDisabled={disabled}
      hostingId={hostingId}
      onAction={onAction}
      {...props}
    >
      {children}
    </SSOComponent>
  );
};

export default ResellerWhmSSO;
